module.exports = __webpack_public_path__ + "img/chat-loading@3x.e98398b7.png";